import React from 'react';
import { cn } from '../lib/utils';

interface FeverOverlayProps {
  isActive: boolean;
}

// FIX: Replaced two Framer Motion infinite-loop divs (one with scale+opacity,
// one with boxShadow+borderWidth) with pure CSS animations.
// - scale/boxShadow on full-screen divs force paint+composite every frame.
// - CSS opacity-only animation is GPU-composited with zero layout cost.
// - Border pulse done via CSS box-shadow keyframe on a single element.
export default function FeverOverlay({ isActive }: FeverOverlayProps) {
  if (!isActive) return null;
  return (
    <>
      {/* Full-screen glow — CSS opacity pulse, GPU-composited */}
      <div className="absolute inset-0 bg-yellow-400 mix-blend-overlay pointer-events-none z-40 animate-fever-glow" />
      {/* Pulsing border — CSS box-shadow pulse only, no layout thrash */}
      <div className="absolute inset-0 pointer-events-none z-[100] animate-fever-border rounded-[32px] sm:rounded-none" />
    </>
  );
}
